module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"spacing_system":{"description":"크리마 리뷰는 4px spacing system을 기본으로 적용합니다.\\n다만 디자이너가 시스템에 적절한 크기가 없다고 판단할 경우 짝수 단위로 공간을 추가할 수 있습니다."}}}')
  delete Component.options._Ctor
}
